import { render } from "./RequestPasswordReset.vue?vue&type=template&id=33cd0ddf&scoped=true"
import script from "./RequestPasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&setup=true&lang=js"

import "./RequestPasswordReset.vue?vue&type=style&index=0&id=33cd0ddf&scoped=true&lang=css"
import "./RequestPasswordReset.vue?vue&type=style&index=1&id=33cd0ddf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cd0ddf"],['__file',"src/views/RequestPasswordReset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33cd0ddf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33cd0ddf', __exports__)) {
    api.reload('33cd0ddf', __exports__)
  }
  
  module.hot.accept("./RequestPasswordReset.vue?vue&type=template&id=33cd0ddf&scoped=true", () => {
    api.rerender('33cd0ddf', render)
  })

}


export default __exports__